import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { ApiResponse } from 'src/app/main/_models/api-response';
import { NetworkPostData } from 'src/app/network/_components/network/network.component';
import { ApiDatatableResponse } from 'src/app/main/_models/api-datatable-response';
import { LinkPostData } from 'src/app/network/_components/network/network.component';
import { SchedulerRequestPostData } from './planner.service';

@Injectable({
	providedIn: 'root'
})
export class PartnerService {

	constructor(
		private http: HttpClient,
		private config: AppConfig
	) { }

	datatable(data: NetworkPostData) {
		return this.http.post<ApiDatatableResponse>(`${this.config.getConfig("apiEndpoint")}/partners/dt`, data);
	}

	manageLink(l: LinkPostData, action: string) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/partners/link/` + action, l);
	}

	updateLegame(l: LinkPostData) {
		return this.http.put<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/partners/link`, l);
	}

	invite(body: any) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/partners/invite`, body);
	}

	getServices(id: number, data: any) {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/partners/service/${id}`, data);
	}

	requestService(data: SchedulerRequestPostData) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/partners/service/request`, data);
	}

	assignServiceReturnTrip(costo: number, pr: number, id: number) {
		return this.http.post<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/partners/service/prassign`, { costo, pr, id });
	}

	eliminaAlertModificaRequest(id: number) {
		return this.http.delete<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/partners/service/request/alertmodifica/${id}`);
	}

}
